// extracted by mini-css-extract-plugin
export var selectLabel = "SelectSection-module--selectLabel--62d57";
export var selectSection = "SelectSection-module--selectSection--c4fec";